import Vue from 'vue'
import Vuex from 'vuex'
import VueClipboard from 'vue-clipboard2'
import VueRouter from 'vue-router'
import BootstrapVue from 'bootstrap-vue'
import BootstrapVueTreeview from 'bootstrap-vue-treeview'
import axios from 'axios'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/assets/css/custom.css'
import VModal from 'vue-js-modal'
import VTooltip from 'v-tooltip'
import { d2CrudPlus } from 'd2-crud-plus'
import d2CrudX from 'd2-crud-x'

import App from '@/App.vue'
import Login from '@/components/Login.vue'
import MainPage from '@/components/MainPage.vue'
import AddPoem from '@/components/AddPoem.vue'
import Guide from '@/components/Guide.vue'
import Datasets from '@/components/Datasets.vue'
import About from '@/components/About.vue'
import { store } from '@/store.js'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en'


Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(BootstrapVueTreeview)
Vue.use(Vuex)
Vue.use(VModal)
Vue.use(VueClipboard)
Vue.use(VueRouter)
Vue.use(VTooltip)
Vue.use(ElementUI, { locale })
Vue.use(d2CrudX, { name: 'd2-crud-x' })
Vue.use(d2CrudPlus)
Vue.component('example-helper', () => import('./components/ExampleHelper.vue'))
// setup Vue router
const routes = [
    { path: '/', component: MainPage },
    { path: '/login', component: Login },
    { path: '/add-poem', component: AddPoem },
    { path: '/guide', component: Guide },
    { path: '/datasets', component: Datasets },
    { path: '/about', component: About }
]

const router = new VueRouter({
    base: '/lantern/',
    mode: 'history',
    routes
})

new Vue({
    router: router,
    store: store,
    render: h => h(App),
}).$mount('#app')
